import { normalizePopularSearchItems } from "./popular-search-data";

const POPULAR_SEARCH_CACHE_KEY = "hotple.popularSearches.v1";
const POPULAR_SEARCH_CACHE_TTL_MS = 10 * 60 * 1000;

export const getCachedPopularSearches = () => {
  if (typeof window === "undefined") return [];

  try {
    const parsed = JSON.parse(
      window.localStorage.getItem(POPULAR_SEARCH_CACHE_KEY) || "null"
    );
    const items = Array.isArray(parsed) ? parsed : parsed?.data;
    const cachedAt = Number(parsed?.cachedAt || 0);
    if (cachedAt && Date.now() - cachedAt > POPULAR_SEARCH_CACHE_TTL_MS) {
      window.localStorage.removeItem(POPULAR_SEARCH_CACHE_KEY);
      return [];
    }
    return normalizePopularSearchItems(items);
  } catch {
    return [];
  }
};

export const saveCachedPopularSearches = (items) => {
  if (typeof window === "undefined") return;
  const normalizedItems = normalizePopularSearchItems(items);
  if (normalizedItems.length === 0) return;

  window.localStorage.setItem(
    POPULAR_SEARCH_CACHE_KEY,
    JSON.stringify({
      data: normalizedItems,
      cachedAt: Date.now(),
    })
  );
};
